import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";

import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { UploadControlCenterInstance, joyspaceKey } from "@/components/UploadBox/UploadControl";
import { UploadProps } from "antd/lib/upload/interface";
import Dragger from "antd/lib/upload/Dragger";
import IconFont from "@/components/icon";
import { PermissionEnum } from "../../const";
import "./index.less";
import {
  GroupUploadControlCenterInstance,
  groupJoyspaceKey
} from "../GroupUploadPanel/UploadController";
import { handleUploadDrag } from "../UploadBox/util";
import { folderType } from "../../config/permissions.config";
import events from "../../context/events";

interface IProps {
  toId?: string;
  toName?: string;
  permissions?: any[];
  gid?: string;
  from?: string;
}

let flag = true;
function UploadDrag(props: IProps) {
  const { toId = "", toName = "", permissions = [], gid = "", from } = props;
  const { appRuntimeEnv, onLine } = useContext<GlobalContextConfig>(GlobalContext);
  const [dragState, setDragState] = React.useState(false);
  const options = useMemo(() => {
    const isMySpace = toId === "myspace";
    const folderId = isMySpace ? "" : toId;
    const fromName = isMySpace ? "" : toName;
    let uploadControlInstance: any;
    if (gid) {
      uploadControlInstance =
        GroupUploadControlCenterInstance.get(groupJoyspaceKey) ||
        GroupUploadControlCenterInstance.register(groupJoyspaceKey, true, gid);
    } else {
      uploadControlInstance = UploadControlCenterInstance.get(joyspaceKey);
    }
    return {
      appRuntimeEnv,
      spaceId: gid,
      folderId,
      fromName,
      from,
      uploadControlInstance,
      callback: (isDragState: boolean) => {
        setDragState(isDragState);
      }
    };
  }, [toId, toName, appRuntimeEnv, gid, from]);
  const onDrag = useCallback(
    (e) => {
      flag = true;
      if (e.type === "dragenter" && flag) {
        events.emit("hideContextMenus");
        flag = false;
      }
      if (!e.dataTransfer.types || !e.dataTransfer.types.includes("Files")) {
        return;
      }
      if (
        !(permissions.includes(PermissionEnum.PAGE_CREATE) || toId === folderType.SHARE) &&
        e.type === "drop"
      ) {
        setDragState(false);
        return;
      }
      handleUploadDrag(e, options);
    },
    [permissions, options, toId]
  );
  useEffect(() => {
    const node: any = document.getElementsByClassName("joyspace-drop")[0];
    if (!node) {
      return;
    }
    if (dragState) {
      node.classList.add("joyspace-main-list-drop");
      return;
    }
    node.classList.remove("joyspace-main-list-drop");
  }, [dragState]);
  useEffect(() => {
    const node: any = document.getElementsByClassName("joyspace-drop")[0];
    if (!node) {
      return;
    }
    node.addEventListener("dragenter", onDrag);
    node.addEventListener("dragover", onDrag);
    node.addEventListener("drop", onDrag);
    return () => {
      node.removeEventListener("dragenter", onDrag);
      node.removeEventListener("dragover", onDrag);
      node.removeEventListener("drop", onDrag);
    };
  }, [onDrag]);
  const uploadProps: UploadProps = {
    multiple: true, // 支持多文件上传 IE10+
    name: "files", // 传到后台的文件参数名称
    showUploadList: false, // 是否展示上传文件列表
    customRequest: (_param: any) => {}
  };
  const canUpload = useMemo(() => {
    if (toId === "myspace" || toId === folderType.SHARE) {
      return true;
    }
    return permissions.includes(PermissionEnum.PAGE_CREATE);
  }, [permissions, toId]);
  const uploadTips = useMemo(() => {
    if (canUpload) {
      return options.fromName ? `上传到${options.fromName}` : "上传到我的文件";
    }
    return "您暂无上传权限";
  }, [canUpload, options.fromName]);
  return (
    <div
      className={`joyspace-main-list-dragger ${
        dragState && onLine ? "joyspace-dragger-show-drop" : ""
      }`}
      onDragLeave={(e: any) => {
        // e?.persist();
        onDrag(e);
      }}
    >
      {onLine && (
        <Dragger className="dragger-box" {...uploadProps}>
          <div className={canUpload ? "dragger-center" : "dragger-center dragger-center-disabled"}>
            <IconFont type={canUpload ? "iconpc_ic_upload_doc" : "iconapp_ic_Moreinformation"} />
            <span className="dragger-box-text">{uploadTips}</span>
          </div>
        </Dragger>
      )}
    </div>
  );
}
export default UploadDrag;
